module.exports = __webpack_public_path__ + "img/login-bg.3cffd931.png";